import { jsPDF } from 'jspdf';
import { format } from 'date-fns';

export interface RetainerSignature {
    name: string;
    signedAt: string;
}

export const buildRetainerPdfBlobUrl = (
    text: string,
    signatures: RetainerSignature[] = [],
    heading = 'Retainer Agreement'
): string => {
    const doc = new jsPDF();

    const margin = 20;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const lineHeight = 6;
    const maxWidth = pageWidth - margin * 2;

    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(heading, margin, margin);

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    let yOffset = margin + 15;

    const drawWrappedLine = (line: string) => {
        const wrapped = doc.splitTextToSize(line, maxWidth);
        for (const segment of wrapped) {
            if (yOffset + lineHeight > pageHeight - margin) {
                doc.addPage();
                yOffset = margin;
            }
            doc.text(segment, margin, yOffset);
            yOffset += lineHeight;
        }
    };

    drawWrappedLine(text || '');

    // const signed = signatures
    //     .filter(s => s.signedAt)
    //     .sort((a, b) => new Date(a.signedAt).getTime() - new Date(b.signedAt).getTime());
    //
    // if (signed.length > 0) {
    //     yOffset += 10;
    //     for (const s of signed) {
    //         const formatted = format(new Date(s.signedAt), "MMMM do, yyyy 'at' h:mm a");
    //         drawWrappedLine(`Agreed to by ${s.name} on ${formatted}.`);
    //     }
    // }

    const blob = doc.output('blob') as Blob;
    return window.URL.createObjectURL(blob);
};
